import { Component, Input } from '@angular/core'
import { AppPaths } from 'src/app/app-routing.module'
import { AppStateService } from 'src/app/core/services/app-state.service'
import { signTypesPropertyFilterKey } from 'src/app/shared/utils/property-filter.utils'

@Component({
  selector: 'app-property-filters-data',
  templateUrl: './property-filters-data.component.html',
  styleUrls: ['./property-filters-data.component.scss'],
  standalone: false,
})
export class PropertyFiltersDataComponent {
  @Input() appPath!: AppPaths
  @Input() description = 'Custom Filters'
  @Input() excludedKeys: string[] = [signTypesPropertyFilterKey]

  customFiltersInput: string = ''

  get activeCustomFilters(): { key: string; value: string }[] {
    return Object.entries(this.appState.selectPropertyFilters())
      .filter(([key]) => !this.excludedKeys.includes(key))
      .map(([key, value]) => ({ key, value }))
  }

  constructor(private appState: AppStateService) {
    this.initCustomFiltersInput()
  }

  private initCustomFiltersInput(): void {
    const filters = this.appState.selectPropertyFilters()
    this.customFiltersInput = Object.entries(filters)
      .filter(([key]) => !this.excludedKeys.includes(key))
      .map(([key, value]) => `${key}=${value}`)
      .join(', ')
  }

  private writePropertyFilters(next: Record<string, string>): void {
    const serialized = Object.entries(next)
      .map(([k, v]) => `${k}=${v}`)
      .join(',')

    this.appState.setState(this.appPath, {
      propertyFilters: serialized || undefined,
    })
  }

  applyCustomFilters(): void {
    if (!this.appPath) {
      throw new Error('app-property-filters-data requires [appPath] to be provided by the view')
    }

    const existing = this.appState.selectPropertyFilters()
    const next: Record<string, string> = {}

    Object.entries(existing).forEach(([key, value]) => {
      if (this.excludedKeys.includes(key) || !this.excludedKeys.includes(key)) {
        next[key] = value
      }
    })

    this.customFiltersInput
      .split(',')
      .map((s) => s.trim())
      .filter((s) => s.includes('=') && s.length > 2)
      .forEach((entry) => {
        const eqIdx = entry.indexOf('=')
        const key = entry.slice(0, eqIdx).trim()
        const value = entry.slice(eqIdx + 1).trim()
        if (key) {
          next[key] = value
        }
      })

    this.writePropertyFilters(next)
    this.customFiltersInput = ''
  }

  removeCustomFilter(removeKey: string): void {
    const existing = this.appState.selectPropertyFilters()
    const next = Object.fromEntries(Object.entries(existing).filter(([key]) => key !== removeKey))
    this.writePropertyFilters(next)
  }

  clearCustomFilters(): void {
    const existing = this.appState.selectPropertyFilters()
    const next: Record<string, string> = {}

    Object.entries(existing).forEach(([key, value]) => {
      if (this.excludedKeys.includes(key)) {
        next[key] = value
      }
    })

    this.writePropertyFilters(next)
    this.customFiltersInput = ''
  }
}
